import MobileStatusFlow from "./MobileStatusFlow";

export default function MobileStatusView() {
  return (
    <div className="flex flex-col">
      <MobileStatusFlow
        flowKey="correios"
        title="Entrega pelos Correios"
      />
      <MobileStatusFlow
        flowKey="presencial"
        title="Entrega presencial"
      />
      <MobileStatusFlow
        flowKey="hub"
        title="Entrega por parceiros"
      />
    </div>
  );
}
